import request from '@/utils/request'

const getUser = {

  login(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/login',
      method: 'post',
      data // 等同于 data: data
    })
  },

  index(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/index',
      method: 'post',
      data // 等同于 data: data
    })
  },

  set(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/set',
      method: 'post',
      data // 等同于 data: data
    })
  },

  get(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/get',
      method: 'post',
      data // 等同于 data: data
    })
  },

  addCard(data) {
    return request({
      url: '/api/user/addCard',
      method: 'post',
      data
    })
  },
  batchAddCards(data) {
    return request({
      url: '/api/user/batchAddCards',
      method: 'post',
      data
    })
  },
  forceClaimCards(data) {
    return request({
      url: '/api/user/forceClaimCards',
      method: 'post',
      data
    })
  },
  subCard(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/subCard',
      method: 'post',
      data // 等同于 data: data
    })
  },

  rest(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/rest',
      method: 'post',
      data // 等同于 data: data
    })
  },

  restAll(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/restAll',
      method: 'post',
      data // 等同于 data: data
    })
  },

  upCard(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/upCard',
      method: 'post',
      data // 等同于 data: data
    })
  },

  downCard(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/downCard',
      method: 'post',
      data // 等同于 data: data
    })
  },

  getData(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/getData',
      method: 'post',
      data // 等同于 data: data
    })
  },

  click(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/click',
      method: 'post',
      data // 等同于 data: data
    })
  },

  unclick(data) {
    // data 是请求体数据（适用于提交表单、JSON 数据等）
    return request({
      url: '/api/user/unclick',
      method: 'post',
      data // 等同于 data: data
    })
  },



}

export default getUser;

